import React, { useEffect,useState } from 'react'
import ActivityItem from './ActivityItem'
import { FaCrown } from 'react-icons/fa'
import axios from 'axios';
import key from '../../key';
import { useCookies } from 'react-cookie';

function ActivitySummary() {
    const [pending, setPending] = useState()
    const [accepted, setAccepted] = useState()
    const [recent, setRecent] = useState()
    const [contacts, setContacts] = useState()
    const [chats, setChats] = useState()
    //eslint-disable-next-line
    const [cookies, setCookie,removeCookie] = useCookies(['x-auth-token']);

    useEffect(() => {
        const getData = async () => {
            try {
                const response = await axios.get(`${key}/api/user/get-activity-summary`,{
                    headers: {
                        'x-auth-token': cookies['x-auth-token']
                    }
                })
                setPending(response?.data?.data?.pending)
                setAccepted(response?.data?.data?.accepted)
                setRecent(response?.data?.data?.visitors)
                setContacts(response?.data?.data?.contactViewed)
                setChats(response?.data?.data?.chats)
            } catch (error) {
                console.log(error)
            }
        }
        getData()
        //eslint-disable-next-line
    }, [])

    return (
        <div>
            <h6 className='text-secondary'>Your Activity Summary</h6>
            <div className='d-flex'>
                <ActivityItem  title={"Pending Invites"} count={pending} link={"/received"} />
                <ActivityItem  title={"Accepted Invites"} count={accepted} link={"/accepted"} />
                <ActivityItem  title={"Recent Visitors"} count={recent} link={"/recently-viewed/recent-visitors"} />
            </div>
            <div className='d-flex'>
            <div className="activity-item">
                <p className='mt-4 normal-text d-flex justify-content-center' style={{alignItems:"center"}}>Your Premium Activity <FaCrown style={{color:"red"}} size={25} /></p>
        </div>
                <ActivityItem  title={"Contacts Viewed"} count={contacts} link={"/recently-viewed/contact-viewed"} />
                <ActivityItem  title={"Chats Initiated"} count={chats} link={"/chat"} />
            </div>
        </div>
    )
}

export default ActivitySummary